import { Typography } from '@workspace/ui/components/Typography';

import { company } from '~/company/Company';

export const EmptyTitleComponent = company.match({
  mcosmetic: Typography.Header150Light,
  default: Typography.Header300Medium,
});
